import { compose } from "redux";
import React, { PureComponent } from "react";

import {
  groupByOverlappingDateRanges,
  getCalendarDateRangeHeight,
  getCalendarDateRangeTopOffset,
  getCalendarDateRangeLeftOffset,
  getCalendarDateRangeRightOffset,
} from "utils/app.util";

import WorkScheduleReportSchedulePeriod from "features/planner/report/workSchedule/components/WorkScheduleReportSchedulePeriod";
import { CALENDAR_DATE_RANGE_TYPE } from "features/planner/planner.constants";

class WorkScheduleReportSchedulePeriods extends PureComponent {
  render() {
    const { employeeCard, startDate, endDate, totalDays } = this.props;

    const deploymentPeriods = employeeCard
      .get("deploymentDetails")
      .map(deploymentDetail =>
        deploymentDetail.set(
          "schedulePeriodType",
          CALENDAR_DATE_RANGE_TYPE.DEPLOYMENT,
        ),
      );

    const overridePeriods = employeeCard
      .get("scheduleOverrides")
      .map(scheduleOverride =>
        scheduleOverride.set(
          "schedulePeriodType",
          CALENDAR_DATE_RANGE_TYPE.AVAILABILITY_OVERRIDE,
        ),
      );

    const allPeriods = deploymentPeriods.concat(overridePeriods);

    return (
      <>
        {groupByOverlappingDateRanges(allPeriods).map(
          (schedulePeriodsGroup, listMapIndex) => {
            const maxIndex = schedulePeriodsGroup
              .maxBy(sp => sp.get("groupIndex", 0))
              .get("groupIndex", 0);

            return schedulePeriodsGroup.map(schedulePeriod => {
              const leftOffset = getCalendarDateRangeLeftOffset(
                startDate,
                totalDays,
                schedulePeriod,
              );

              const rightOffset = getCalendarDateRangeRightOffset(
                endDate,
                totalDays,
                schedulePeriod,
              );

              const index = schedulePeriod.get("groupIndex");

              return (
                <WorkScheduleReportSchedulePeriod
                  left={leftOffset}
                  right={rightOffset}
                  schedulePeriod={schedulePeriod}
                  key={listMapIndex}
                  transform={getCalendarDateRangeTopOffset(index)}
                  height={getCalendarDateRangeHeight(maxIndex + 1)}
                />
              );
            });
          },
        )}
      </>
    );
  }
}

export default compose()(WorkScheduleReportSchedulePeriods);
